import { useEffect, useState } from 'react';
import { onResize$ } from 'utils/onResize';

const DEFAULT_BREAKPOINT = 768;

function useIsMobile(breakPoint: number = DEFAULT_BREAKPOINT) {
  const [isMobile, setViewport] = useState(window.innerWidth < breakPoint);

  useEffect(() => {
    const subscription = onResize$()
      .map(() => window.innerWidth)
      .distinctUntilChanged()
      .subscribe((width) => setViewport(width < breakPoint));

    return () => subscription.unsubscribe();
  }, [breakPoint]);

  return isMobile;
}

export default useIsMobile;
